import { useLingui } from '@lingui/react/macro';
import { useMemo } from 'react';

export function useKBWebsiteHierarchyLabels() {
  const { t } = useLingui();

  return useMemo(
    () => ({
      addToTrackedPagesLabel: t`Add to tracked pages`,
      removeFromTrackedPagesLabel: t`Remove from tracked pages`,
      removeFromTrackedPagesDisclaimer: t`Items that belong to a tracked website cannot be permanently deleted here. They can only be removed from tracked pages.`,
      promoteToWebsiteHierarchyHint: t`Promote selected website documents into a tracked hierarchy. Leave the path empty to track the whole site, or set a prefix (e.g. /blog) to group only that subpath — same as when adding a website.`,
      webHierarchyCutDisabledTooltip: t`Changes are not allowed in website hierarchy folders`,
      globalKbCutDisabledTooltip: t`Cut is only available in the global Knowledge Base`,
    }),
    [t],
  );
}
